export const columnsHeadingFontKeys = {
    md: ['Primary/32_94_-2_700', null, null, 'Primary/40_94_-2_700'],
    lg: ['Primary/48_94_-2_700', null, 'Primary/64_94_-2_700', null, 'Primary/96_94_-1_700'],
};
